<template>
    <div id="statusIndicator">{{ msg }}</div>
</template>

<script>
export default {
  name: "Status",
  props: [
    'msg'
  ],
}
</script>

<style>
#statusIndicator {
  padding: 5px;
  border-radius: 10px;
  background: orange;
  position: absolute;
  opacity: 0;
  top: 0;
  transition: all 1s ease;
}
</style>


